import { ApplicationConfig, inject, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { AuthService } from '@lib/auth/auth.service';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { InMemoryCache } from '@apollo/client/cache';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApolloLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { DemandeAffiliationBackOfficeService } from './demandes-affiliation/services/demande-affiliation-backoffice.service';
import { ApereoAuthService } from '@lib/auth/apereo-auth.service';
import {
  COMMON_ENVIRONMENT,
  CommonEnvironment,
} from '@lib/core/environment/common-environment';
import { environment } from '../environments/environment';
import { GraphQlDemandeAffiliationBackofficeService } from './demandes-affiliation/services/graphql/graphql-demande-affiliation-backoffice.service';
import { GedService } from '@lib/ged/ged.service';
import { AzureGedService } from '@lib/ged/azure-ged.service';
import { ControleDocumentsService } from '@lib/components/controle-documents/services/controle-documents.service';
import { DemandeControleService } from './controle-demande/services/demande-controle.service';
import { APP_AUDIENCE } from '@lib/core/environment/app-audience';
import { DemandeValidationPjBackOfficeService } from './demandes-validation-pj/services/demande-validation-pj-backoffice.service';
import { GraphQlDemandeValidationPjBackOfficeService } from './demandes-validation-pj/services/graphql/graphql-demande-validation-pj-backoffice.service';
import { DemandeHabilitationsBackOfficeService } from './demandes-habilitation/services/demande-habilitations-backoffice.service';
import { GraphQlDemandeHabilitationsBackOfficeService } from './demandes-habilitation/services/graphql/graphql-demande-habilitations-backoffice.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withFetch()),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      const authService = inject(AuthService);

      const authLink = setContext(async (_, { headers }) => {
        const token = await authService.getToken();
        return {
          headers: {
            ...headers,
            Authorization: token ? `Bearer ${token}` : '',
          },
        };
      });

      return {
        link: ApolloLink.from([
          authLink,
          httpLink.create({
            uri: environment.graphqlUri,
          }),
        ]),
        cache: new InMemoryCache(),
      };
    }),
    {
      provide: COMMON_ENVIRONMENT,
      useValue: environment as CommonEnvironment,
    },
    { provide: AuthService, useClass: ApereoAuthService },
    {
      provide: DemandeAffiliationBackOfficeService,
      useClass: GraphQlDemandeAffiliationBackofficeService,
    },
    {
      provide: DemandeValidationPjBackOfficeService,
      useClass: GraphQlDemandeValidationPjBackOfficeService,
    },
    {
      provide: DemandeHabilitationsBackOfficeService,
      useClass: GraphQlDemandeHabilitationsBackOfficeService,
    },
    {
      provide: GedService,
      useClass: AzureGedService,
    },
    // TODO provide subset
    {
      provide: ControleDocumentsService,
      useClass: DemandeControleService,
    },
    {
      provide: APP_AUDIENCE,
      useValue: 'shm',
    },
  ],
};
